<script setup lang="ts">
/**
 * 로그인 전용 레이아웃
 * - 프로토타입 카드 스타일(`.card`)을 셸 위 기준에 배치한다(단계가 바뀌어 카드 높이가 달라져도 로고 머리가 튀지 않는다).
 * - 카드 안 로고 머리(`BrandHeader` → `.brand`)의 여백 · 구분선 · 부제 모양은 오류 · 공개 링크 화면과 함께 main.scss 공용 규칙이 준다
 *   (예전에는 이 파일 scoped 에 있었다).
 * - 80차 UXA80-07: 셸 위 여백(`clamp(24px, 10vh, 96px)`)만으로는 카드가 화면 위쪽에 붙어 아래가 휑했다(1440 × 900 에서 위 90 · 아래 325). 카드를
 *   시각 중심(위 약 18vh)쪽으로 `clamp(0px, 8vh, 72px)` 만큼 더 내린다 — 셸 여백과 합쳐도 `max(48px, 12vh)` 안팎이 아니라 18vh 라 낮은 창(≤600)에서는 0 에 가깝다.
 *   단계가 바뀌어 카드 높이가 달라져도 위 기준선은 그대로(아래로 자란다) — 로고 머리는 튀지 않는다.
 */
</script>

<template>
  <!-- data-ui-layout-root: 모달이 떠 있는 동안 overlay.ts 가 inert 를 거는 배경(74차 UXV74-06) -->
  <div class="auth-shell" data-ui-layout-root>
    <div class="auth-card">
      <RouterView />
    </div>
  </div>
</template>

<style scoped>
.auth-card {
  margin-top: clamp(0px, 8vh, 72px);
}
</style>
